// utils/SerialPortHelper.js
class SerialPortHelper {
  constructor() {
    // 串口物理连接
    this.port = null;
    this.reader = null;
    this.keepReading = false;
    this.receivedBuffer = '';
    this.baudRate = 115200;
    this.snCode = "none"; //none 代表没读取到,重新发一个指令

    // 全局状态
    this.state = {
      isConnected: false,
      isReading: false,
      lastError: null
    };

    // 事件系统
    this.events = {
      'connection-change': new Set(),
      'data-received': new Set(),
      'data-sent': new Set(),
      'error': new Set()
    };
  }

  // 事件监听
  on(eventName, callback) {
    if (this.events[eventName]) {
      this.events[eventName].add(callback);
    }
  }

  // 移除监听
  off(eventName, callback) {
    if (this.events[eventName]) {
      this.events[eventName].delete(callback);
    }
  }

  // 触发事件
  _emit(eventName, data) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(cb => cb(data));
    }
  }

  // 更新状态并触发事件
  _updateState(updates) {
    this.state = { ...this.state, ...updates };
    if ('isConnected' in updates) {
      this._emit('connection-change', {
        isConnected: this.state.isConnected
      });
    }
  }

  async connect(baudRate = 115200) {
    try {
      if (!this.isSupported()) {
        throw new Error('Web Serial API not supported');
      }

      this.port = await navigator.serial.requestPort();


      this.port.addEventListener('disconnect', this._handleDisconnect.bind(this));

      await this.port.open({ baudRate });
      this.baudRate = baudRate;

      this._updateState({
        isConnected: true,
        lastError: null
      });

      this._startReading();
      //连接成功，多读取两遍序列号
      this.readSNCode();
      this.readSNCode();
      this.readSNCode();
    } catch (error) {
      this._updateState({
        lastError: error.message
      });
      this._emit('error', error);
      throw error;
    }
  }


  async _handleDisconnect() {

    this._updateState({
      isConnected: false,
      isReading: false,
      lastError: 'Port disconnected'
    });

    this._emit('error', new Error('Port disconnected'));
    this._emit('connection-change', { isConnected: false });

    // 清理资源
    this.port = null;
    this.reader = null;
    this.keepReading = false;
    this.receivedBuffer = '';
    this.snCode = "none"; //none 代表没读取到,重新发一个指令
  }


  async disconnect() {
    this.keepReading = false;

    try {
      if (this.reader) {
        await this.reader.cancel();
        this.reader = null;
      }

      if (this.port) {
        // 移除断开连接事件监听
        this.port.removeEventListener('disconnect', this._handleDisconnect);
        await this.port.close();
        this.port = null;
      }

      if (this.port) {
        await this.port.close();
        this.port = null;
      }

      this._updateState({
        isConnected: false,
        isReading: false
      });
    } catch (error) {
      this._updateState({
        lastError: error.message
      });
      this._emit('error', error);
      throw error;
    }
  }
  async readSNCode(){
    this.send("YSYS");
  }
  async send(text) {
    if (!this.state.isConnected) {
      throw new Error('Port not connected');
    }

    if (typeof text !== 'string') {
      throw new Error('Only string data is supported');
    }

    const writer = this.port.writable.getWriter();
    try {
      // 字符串编码为Uint8Array
      const encodedData = new TextEncoder().encode(text + '\n');
      await writer.write(encodedData);

      this._emit('data-sent', text);
    } catch (error) {
      this._updateState({ lastError: error.message });
      this._emit('error', error);
      throw error;
    } finally {
      writer.releaseLock();
    }
  }

  async _startReading() {
    if (!this.port || !this.port.readable) return;

    this.keepReading = true;
    this._updateState({ isReading: true });

    try {
      this.reader = this.port.readable.getReader();

      while (this.keepReading) {
        const { value, done } = await this.reader.read();
        if (done) break;

        const text = new TextDecoder().decode(value);
        // 1. 将新数据追加到缓冲区
        this.receivedBuffer += text;

        // 2. 按行分割数据（假设换行符是 \n）
        const lines = this.receivedBuffer.split('\n');

        // 3. 如果最后一行不完整（没有换行符），保留在缓冲区
        this.receivedBuffer = lines.pop() || '';
        lines.forEach(line => {
          if (line.trim()) {
            console.log(line);
            this.dealInfo(line);
            this._emit('data-received', line);
          }
        });

      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        this._updateState({
          lastError: error.message
        });
        this._emit('error', error);
      }
    } finally {
      if (this.reader) this.reader.releaseLock();
      this._updateState({ isReading: false });
    }
  }

  dealInfo(text){
    // 1. 移除所有 \r 和 \n
    const cleanedText = text.replace(/[\r\n]/g, '');
    const parts = cleanedText.split('#');
    //系统信息
    if (parts.length == 3 && parts[0] == "YSYS") {
      this.snCode = parts[2];
      console.log(this.snCode)
    }
  }

  isSupported() {
    return 'serial' in navigator;
  }

  getPortInfo() {
    if (!this.port) return null;
    return {
      ...this.port.getInfo(),
      baudRate: this.baudRate,
      isConnected: !!this.port
    };
  }
}

// 导出单例
export const serialPort = new SerialPortHelper();



// WEBPACK FOOTER //
// ./src/tcode/SerialPortHelper.js